import type { Step } from '@/components/wizard/Step';

import type { SetupVpcPeeringWizardState } from './setupVpcPeeringWizardState';
import { SetupVpcPeeringStep } from './steps/SetupVpcPeeringStep';

export const SetupVpcPeeringCreationFlow: Step<SetupVpcPeeringWizardState> = {
  id: 'setup_vpc_peering',
  Component: SetupVpcPeeringStep,
};
